import React from 'react';
import {domain} from '../../common/config.js';
import pokerTable from '../../img/pokerTable.png';
import Dialog from 'material-ui/Dialog';
import './css/desktop-replayer.css'
import FontAwesome from 'react-fontawesome';
import ReplayerShareDialog  from './ReplayerShareDialog/ReplayerShareDialog'
import i18next from 'i18next';

let baseUrl = "//"+domain+"/images";
export default class DesktopReplayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableImage: baseUrl+"/replayerElements/newTable.png",
      playIcon: baseUrl+"/replayerElements/play.png",
      pauseIcon: baseUrl+"/replayerElements/pause.png",
      replay: baseUrl+"/replayerElements/replay.png",
      backward: baseUrl+"/replayerElements/backward.png",
      forward: baseUrl+"/replayerElements/forward.png",
      dealerButton: baseUrl+"/pokerChips/dealerButton.png",
      shareIcon: baseUrl+"/shareIcon.jpg",
      gameType:'',
      loggedInType: localStorage.getItem('loggedInType')
    }
  }
  render() {
    const {
      slide,
      smallBlind,
      bigBlind,
      gameNo,
      playerAlias,
      gameTypeForTitle,
      isShareDialogOpen,
      closeShareDialog,
      openShareDialog,
      partitionDate,
      accountName,
      slideLength,
      slideIndex,
      boosterImages,
      booster,
      boosterType,
      boosterAmount
    } = this.props;
    let seat1,seat2,seat3,seat4,seat5,seat6,seat7,seat8,seat9,seat10;
    seat1 = slide.seats[0];
    seat2 = slide.seats[1];
    seat3 = slide.seats[2];
    seat4 = slide.seats[3];
    seat5 = slide.seats[4];
    seat6 = slide.seats[5];
    seat7 = slide.seats[6];
    seat8 = slide.seats[7];
    seat9 = slide.seats[8];
    seat10 = slide.seats[9];
    if(this.props.gameTypeForTitle){
       this.state.gameType =this.props.gameTypeForTitle.charAt(0).toUpperCase()+ this.props.gameTypeForTitle.slice(1)+' '+'Game';
    } 

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
        // console.log(gameTypeForTitle,"DESKTOP");
        
    return (
      <div className="container">
        <ReplayerShareDialog
          smallBlind={smallBlind}
          loggedInType={this.state.loggedInType}
          bigBlind={bigBlind}
          gameNo={gameNo}
          playerAlias={playerAlias}
          gameTypeForTitle={gameTypeForTitle}
          isOpen={isShareDialogOpen}
          onClose={closeShareDialog}
          partitionDate={partitionDate}
          accountName={accountName}
        />
      <div className="gridForTitle">
      <span className="titleCss" style={{marginTop: '70px', justifySelf: 'left'}}> {this.state.gameType} - {smallBlind}/{bigBlind}</span> 
          {this.props.replayerScreen === 'desktop' ?
            <div>
              <button data-e2e="shareButtonRC" style={{marginTop : "0px"}} className='shareButton' onClick={openShareDialog}>
                {i18next.t("lable.SHAREHAND")}
              </button>
              <button data-e2e="closeButtonRC" className='closeButton btnHalo' onClick={this.props.onClose} >
                <FontAwesome className='centre' name='fas fa-times' style={{ fontSize: '20px', color: 'white' }} />
              </button>
            </div> : <div>
            <button className='closeButton btnHalo' onClick={this.props.onClose} >
                <FontAwesome className='centre' name='fas fa-times' style={{ fontSize: '20px', color: 'white' }} />
              </button>
            </div>
          }
      </div>
        {(slideIndex === 0 || slideLength - 1 === slideIndex) && booster !== "N" &&
          <div className="booster-img-dev">
            <img className="booster-img-desktop"
              src={`https://mygame-dev.mypartypokerlive.com/images/Booster/${boosterImages[boosterType][slideLength - 1 === slideIndex ? "amount" : "normal"]}`} />
              {slideLength-1 === slideIndex && <div className="booster-amount-hands">
                  <span>{`+$`+boosterAmount}</span>
                  </div>}
          </div>}
      
      <div id="container" className="handRepFont" style={{height:"80%",marginTop:"4%"}}>
      
        <div className="row" id="playerTable">
          <center>
            <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
              <img className="poker-table" src={this.state.tableImage} alt="Poker Table"/>
            </div>
          </center>
        </div>
        <div className="row" id="firstRowPlayers" style={{padding: "2% 0% 5% 0%"}}>
          <div className="col-md-3 col-xs-3">
          </div>
          <div className="col-md-6 col-xs-6">
            <div className="row">
              <div className="col-md-1 col-xs-1">
              </div>
              {/*seat 7*/}
              <div className="topSeatPositions col-md-2 col-xs-2">
                <div className="row" style={{marginLeft:'-5px'}}>
                  <div className="col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                    <span style={{float: 'right'}}>
                      <div>
                        {(seat7.cards.length == 4)
                          ?seat7.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha" />
                          })
                          :seat7.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal" />
                        })}
                      </div>
                      <div style={seat7.display.style}>{seat7.display.text}</div>
                      <div style={seat7.coinStack.style}>{numberWithCommas(seat7.coinStack.amount)}</div>
                    </span>
                  </div>
                  <div className="seatPadding col-md-7 col-xs-6" style={{padding: '5px'}}>
                    <img src={seat7.displayPicture} className="firstRowSeats" style={{float: 'left'}}/>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-xs-2">
              </div>
              {/*seat 8*/}
              <div className="topSeatPositions col-md-2 col-xs-2" >
                <div className="row" style={{marginLeft:'-5px'}}>
                  <div className="seat8Card col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                    <span style={{float: 'right'}}>
                      <div>
                        {(seat8.cards.length == 4)
                          ?seat8.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha"/>
                          })
                          :seat8.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal"/>
                        })}
                      </div>
                      <div style={seat8.display.style}>{seat8.display.text}</div>
                      <div style={seat8.coinStack.style}>{numberWithCommas(seat8.coinStack.amount)}</div>
                    </span>
                  </div>
                  <div className="seatPadding col-md-7 col-xs-6" style={{padding: '5px'}}>
                    <img src={seat8.displayPicture} className="firstRowSeats" style={{float: 'left'}}/>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-xs-2">
              </div>
              {/*seat 9*/}
              <div className="topSeatPositions col-md-2 col-xs-2">
                <div className="row" style={{marginLeft:'-5px'}}>
                  <div className="seatPadding col-md-7 col-xs-6" style={{padding: '5px'}}>
                    <img src={seat9.displayPicture} className="firstRowSeats" style={{float: 'right'}}/>
                  </div>
                  <div className="col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                    <span style={{float: 'left'}}>
                      <div>
                      {(seat9.cards.length == 4)
                        ?seat9.cards.map((card, index) => {
                          return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha"/>
                        })
                        :seat9.cards.map((card, index) => {
                          return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal"/>
                        })}
                        </div>
                        <div style={seat9.display.style}>{seat9.display.text}</div>
                        <div style={seat9.coinStack.style}>{numberWithCommas(seat9.coinStack.amount)}</div>
                      </span>
                  </div>
                </div>
              </div>
              <div className="col-md-1 col-xs-2">
              </div>
            </div>
          </div>
          <div className="col-md-3 col-xs-3">
          </div>
        </div>

        <div className="row" id="firstRowDealer" style={{paddingTop:'10%'}}>
          <div className='col-md-3 col-xs-3'>
          </div>
          <div className='col-md-6 col-xs-6'>
            <div className='col-md-2 col-xs-2'>
            </div>
            {/*seat 7 dealer button*/}
            <div className='col-md-1 col-xs-1'>
              {seat7.dealer
                ? <img className='dealerButton7' src={this.state.dealerButton} style={{width: '100%', marginLeft: '90%', marginTop:'-20px'}}/>
                : <img className='dealerButton7' src={""} style={{width: '100%', marginLeft: '90%', marginTop:'-20px'}}/>
              }
            </div>
            <div className='col-md-3 col-xs-3'>
            </div>
            {/*seat 8 dealer button*/}
            <div className='col-md-1 col-xs-1'>
              {seat8.dealer
                ? <img className='dealerButton8' src={this.state.dealerButton} style={{width: '100%', marginLeft: '90%', marginTop:'-20px'}}/>
                : <img className='dealerButton8' src={""} style={{width: '100%', marginLeft: '90%', marginTop:'-20px'}}/>
              }
            </div>
            <div className='col-md-2 col-xs-2'>
            </div>
            {/*seat 9 dealer button*/}
            <div className='col-md-1 col-xs-1'>
              {seat9.dealer
                ? <img className='dealerButton9' src={this.state.dealerButton} style={{width: '100%', marginTop:'-10px'}}/>
                : <img className='dealerButton9' src={""} style={{width: '100%', marginTop:'-10px'}}/>
              }
            </div>
            <div className='col-md-2 col-xs-2'>
            </div>
          </div>
          <div className='col-md-3 col-xs-3'>
          </div>
        </div>

        <div className="row" id="firstRowCoins" style={{paddingTop:'12%'}}>
          <div className='col-md-3 col-xs-3'>
          </div>
          <div className='col-md-6 col-xs-6'>
            <div className='col-md-1 col-xs-1'>
            </div>
            <div className='col-md-1 col-xs-1'>
            </div>
            {/*seat 7 coins*/}
            <div className='col-md-2 col-xs-2'>
              <div style={{marginTop:"-10%",marginLeft:"10%"}}>
                <div className="row">
                  {seat7.tableStack.imgStack.map((chip, index) => {
                    return (
                      <div key={index} className="col-md-2 col-xs-2" style={{float:'right', padding: '0px', position: 'relative'}}>
                      {chip['chip'+index].map((coinUrl, index) => {
                        return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                      })}
                      </div>
                    )
                  })}
                </div>
                <div className="row" style={{paddingTop:'25%'}}>
                  {seat7.tableStack.amount > 0
                  ? <span className="playerPotAmt" style={{float:'right'}}>
                      {seat7.tableStack.amount}
                    </span>
                  : null}
                </div>
              </div>
            </div>
            <div className='col-md-1 col-xs-1'>
            </div>
            <div className='col-md-1 col-xs-1'>
            </div>
            {/*seat 8 coins*/}
            <div className='topChips col-md-2 col-xs-2' >
              <div style={{marginTop:"-10%"}}>
                <div className="row">
                  {seat8.tableStack.imgStack.map((chip, index) => {
                    return (
                      <div key={index} className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                      {chip['chip'+index].map((coinUrl, index) => {
                        return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                      })}
                      </div>
                    )
                  })}
                </div>
                <div className="row" style={{paddingTop:'25%'}}>
                  {seat8.tableStack.amount > 0
                  ? <span className="playerPotAmt" style={{float:'left'}}>
                      {seat8.tableStack.amount}
                    </span>
                  : null}
                </div>
              </div>
            </div>
            <div className='col-md-1 col-xs-1'>
            </div>
            {/*seat 9 coins*/}
            <div className='col-md-2 col-xs-2'>
              <div style={{marginTop:"-5%"}}>
                <div className="row">
                  {seat9.tableStack.imgStack.map((chip, index) => {
                    return (
                      <div key={index} className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                      {chip['chip'+index].map((coinUrl, index) => {
                        return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                      })}
                      </div>
                    )
                  })}
                </div>
                <div className="row" style={{paddingTop:'25%'}}>
                  {seat9.tableStack.amount > 0
                  ? <span className="playerPotAmt" style={{float:'left'}}>
                      {seat9.tableStack.amount}
                    </span>
                  : null}
                </div>
              </div>
            </div>
            <div className='col-md-1 col-xs-1'>
            </div>
          </div>
          <div className='col-md-3 col-xs-3'>
          </div>
        </div>

        <div className="row" id="tablePot" style={{paddingTop: "11%"}}>
          <div className="col-md-2 col-xs-2">
          </div>
          {/*seat 6 display*/}
          <div className="seat6Margin col-md-1 col-xs-1" style={{marginLeft:'10px'}}>
            <div className="row" style={{marginLeft:'-5px', marginTop:'-75%'}}>
              <div className="col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                <span style={{float: 'right'}}>
                  <div>
                    {(seat6.cards.length == 4)
                      ?seat6.cards.map((card, index) => {
                        return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha" />
                      })
                      :seat6.cards.map((card, index) => {
                        return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal" />
                    })}
                  </div>
                  <div style={seat6.display.style}>{seat6.display.text}</div>
                  <div style={seat6.coinStack.style}>{numberWithCommas(seat6.coinStack.amount)}</div>
                </span>
              </div>
              <div className="seatPadding col-md-7 col-xs-6" style={{padding: '5px'}}>
                <img src={seat6.displayPicture} className="firstRowSeats" style={{float: 'left'}}/>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xs-6">
            <div className="row" style={{marginLeft: '-22px'}}>
              <div className="col-md-1 col-xs-1">
              </div>
              {/*seat 6 dealer+coins*/}
              <div className="col-md-2 col-xs-2">
                {seat6.dealer
                  ? <img className='dealerButton6' src={this.state.dealerButton} style={{width: '25%', marginLeft: '-28%', marginTop:'-20px'}}/>
                  : <img className='dealerButton6' src={""} style={{width: '25%', marginLeft: '-28%', marginTop:'-20px'}}/>
                }
                <div style={{marginTop:"-10%", marginLeft:"10%"}}>
                  <div className="row">
                    {seat6.tableStack.imgStack.map((chip, index) => {
                      return (
                        <div key={index} className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                        {chip['chip'+index].map((coinUrl, index) => {
                          return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                        })}
                        </div>
                      )
                    })}
                  </div>
                  <div className="row" style={{paddingTop:'25%'}}>
                    {seat6.tableStack.amount > 0
                    ? <span className="playerPotAmt" style={{float:'left'}}>
                        {seat6.tableStack.amount}
                      </span>
                    : null}
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-xs-2">
              </div>
              <div className="col-md-2 col-xs-2">
                <div className="row">
                  {this.props.slide.pot.imgStack.map((chip, index) => {
                    return (
                      <div key={index} className="col-md-2 col-xs-2" style={{padding: '0px', position: 'relative'}}>
                      {chip['chip'+index].map((coinUrl, index) => {
                        return <img key={index} src={coinUrl} style={{width: '110%', position: 'absolute', top: index*(-3)}}/>
                      })}
                      </div>
                    )
                  })}
                </div>
                <div style={{paddingTop: '20px'}}>
                  {this.props.slide.pot.amount > 0
                  ? <span className="playerPotAmt">
                  {this.props.slide.pot.amount}
                  </span>
                  : null}
                </div>
              </div>
              <div className="col-md-2 col-xs-2">
              </div>
              {/*seat 10 dealer + cards*/}
              <div className="col-md-2 col-xs-2">
                {seat10.dealer
                  ? <img className='dealerButton10' src={this.state.dealerButton} style={{width: '25%', marginLeft: '85%', marginTop:'-20px'}}/>
                  : <img className='dealerButton10' src={""} style={{width: '25%', marginLeft: '85%', marginTop:'-20px'}}/>
                }
                <div style={{marginRight:"22%",marginLeft:"-7%"}}>
                  <div className="row">
                    {seat10.tableStack.imgStack.map((chip, index) => {
                      return (
                        <div key={index} className="col-md-2 col-xs-2" style={{float:'right', padding: '0px', position: 'relative'}}>
                        {chip['chip'+index].map((coinUrl, index) => {
                          return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                        })}
                        </div>
                      )
                    })}
                  </div>
                  <div className="row" style={{paddingTop:'25%'}}>
                    {seat10.tableStack.amount > 0
                    ? <span className="playerPotAmt" style={{float:'right'}}>
                        {seat10.tableStack.amount}
                      </span>
                    : null}
                  </div>
                </div>
              </div>
              <div className="col-md-1 col-xs-1">
              </div>
            </div>
          </div>
          {/*Seat 10 display*/}
          <div className="col-md-1 col-xs-1" style={{marginLeft:'-20px'}}>
            <div className="row" style={{marginRight:'-5px', marginTop:'-75%'}}>
              <div className="seat10 col-md-7 col-xs-7" style={{padding: '5px'}}>
                <img src={seat10.displayPicture} className="firstRowSeats" style={{float: 'right'}}/>
              </div>
              <div className="seat10Card col-md-5 col-xs-5" style={{padding: '5px', marginTop: '-30px'}}>
                <span style={{float: 'left'}}>
                  <div>
                    {(seat10.cards.length == 4)
                      ?seat10.cards.map((card, index) => {
                        return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha" />
                      })
                      :seat10.cards.map((card, index) => {
                        return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal" />
                    })}
                  </div>
                  <div style={seat10.display.style}>{seat10.display.text}</div>
                  <div style={seat10.coinStack.style}>{numberWithCommas(seat10.coinStack.amount)}</div>
                </span>
              </div>

            </div>
          </div>
          <div className="col-md-2 col-xs-2">
          </div>
        </div>

        <div className="row" id="tableCards" style={{paddingTop: "10%"}}>
          <div className="col-md-2 col-xs-2">
          </div>
          {/*Seat 5 display*/}
          <div className="col-md-1 col-xs-1" style={{marginLeft:'14px'}}>
            <div className="row" style={{marginLeft:'-5px', marginTop:'-30%'}}>
              <div className="seat5Cards col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                <span style={{float: 'right'}}>
                  <div>
                    {(seat5.cards.length == 4)
                      ?seat5.cards.map((card, index) => {
                        return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha" />
                      })
                      :seat5.cards.map((card, index) => {
                        return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal" />
                    })}
                  </div>
                  <div style={seat5.display.style}>{seat5.display.text}</div>
                  <div style={seat5.coinStack.style}>{numberWithCommas(seat5.coinStack.amount)}</div>
                </span>
              </div>
              <div className="seatPadding col-md-7 col-xs-6" style={{padding: '5px'}}>
                <img src={seat5.displayPicture} className="firstRowSeats" style={{float: 'left'}}/>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xs-6">
            <div className="row" style={{marginLeft:'-20px'}}>
              <div className="col-md-1 col-xs-1">
              </div>
              {/*seat 5 dealer + cards*/}
              <div className="col-md-2 col-xs-2">
                {seat5.dealer
                  ? <img className='dealerButton5' src={this.state.dealerButton} style={{width: '25%', marginLeft: '-23%', marginTop:'-20px'}}/>
                  : <img className='dealerButton5' src={""} style={{width: '25%', marginLeft: '-23%', marginTop:'-20px'}}/>
                }
                <div style={{marginTop:"-80%",marginLeft:"10%"}}>
                  <div className="row">
                    {seat5.tableStack.imgStack.map((chip, index) => {
                      return (
                        <div key={index} className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                        {chip['chip'+index].map((coinUrl, index) => {
                          return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                        })}
                        </div>
                      )
                    })}
                  </div>
                  <div className="row" style={{paddingTop:'25%'}}>
                    {seat5.tableStack.amount > 0
                    ? <span className="playerPotAmt" style={{float:'left'}}>
                        {seat5.tableStack.amount}
                      </span>
                    : null}
                  </div>
                </div>
              </div>
              <div className="col-md-1 col-xs-1" style={{marginLeft:'14px'}}>
              </div>
              <div className="col-md-4 col-xs-4">
                <div style={{marginTop: '-15%'}}>
                  {this.props.slide.dealerCards.map((card, index) => {
                    return <img key={index} id={card.imgId} src={card.imgUrl} style={{paddingRight:' 0.2em', width: '15%'}}/>
                  })}
                </div>
              </div>
              <div className="col-md-1 col-xs-1">
              </div>
              {/*seat 1 dealer + cards*/}
              <div className="col-md-2 col-xs-2" style={{marginLeft:'-34px'}}>
                {seat1.dealer
                  ? <img className='dealerButton1' src={this.state.dealerButton} style={{width: '25%', marginLeft: '100%', marginTop:'-30px'}}/>
                  : <img className='dealerButton1' src={""} style={{width: '25%', marginLeft: '100%', marginTop:'-30px'}}/>
                }
                <div className='seat1Chips' style={{marginTop:"-85%",marginLeft:"15%"}}>
                  <div className="row">
                    {seat1.tableStack.imgStack.map((chip, index) => {
                      return (
                        <div key={index} className="col-md-2 col-xs-2" style={{float:'right', padding: '0px', position: 'relative'}}>
                        {chip['chip'+index].map((coinUrl, index) => {
                          return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                        })}
                        </div>
                      )
                    })}
                  </div>
                  <div className="row" style={{paddingTop:'25%'}}>
                    {seat1.tableStack.amount > 0
                    ? <span className="playerPotAmt" style={{float:'right'}}>
                        {seat1.tableStack.amount}
                      </span>
                    : null}
                  </div>
                </div>
              </div>
              <div className="col-md-1 col-xs-1">
              </div>
            </div>
          </div>
          {/*seat 1 dealer + cards*/}
          <div className="col-md-1 col-xs-1" style={{marginLeft:'-30px'}}>
            <div className="row" style={{marginRight:'-5px', marginTop:'-30%'}}>
              <div className="seat1 col-md-7 col-xs-7" style={{padding: '5px'}}>
                <img src={seat1.displayPicture} className="firstRowSeats" style={{float: 'right'}}/>
              </div>
              <div className="seat1Cards col-md-5 col-xs-5" style={{padding: '5px', marginTop: '-30px'}}>
                <span style={{float: 'left'}}>
                  <div>
                    {(seat1.cards.length == 4)
                      ?seat1.cards.map((card, index) => {
                        return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha" />
                      })
                      :seat1.cards.map((card, index) => {
                        return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal" />
                    })}
                  </div>
                  <div style={seat1.display.style}>{seat1.display.text}</div>
                  <div style={seat1.coinStack.style}>{numberWithCommas(seat1.coinStack.amount)}</div>
                </span>
              </div>

            </div>
          </div>
          <div className="col-md-2 col-xs-2">
          </div>
        </div>

        <div className="row" id="secondRowCoins" style={{paddingTop:'28%'}}>
          <div className='col-md-3 col-xs-3'>
          </div>
          <div className='col-md-6 col-xs-6'>
            <div className='col-md-2 col-xs-2'>
            </div>
            {/*seat 4 coins*/}
            <div className='col-md-2 col-xs-2'>
              <div className="seat4Chips" style={{marginTop:"-10%",marginLeft:"10%"}}>
                <div className="row">
                  {seat4.tableStack.imgStack.map((chip, index) => {
                    return (
                      <div key={index} className="col-md-2 col-xs-2" style={{float:'right', padding: '0px', position: 'relative'}}>
                      {chip['chip'+index].map((coinUrl, index) => {
                        return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                      })}
                      </div>
                    )
                  })}
                </div>
                <div className="row" style={{paddingTop:'25%'}}>
                  {seat4.tableStack.amount > 0
                  ? <span className="playerPotAmt" style={{float:'right'}}>
                      {seat4.tableStack.amount}
                    </span>
                  : null}
                </div>
              </div>
            </div>
            <div className='col-md-2 col-xs-2'>
            </div>
            {/*seat 3 coins*/}
            <div className='col-md-2 col-xs-2' >
              <div className="seat3Chips" style={{marginTop:"-15%"}}>
                <div className="row">
                  {seat3.tableStack.imgStack.map((chip, index) => {
                    return (
                      <div key={index} className="col-md-3 col-xs-4" style={{float:'left', padding: '0px', position: 'relative'}}>
                      {chip['chip'+index].map((coinUrl, index) => {
                        return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                      })}
                      </div>
                    )
                  })}
                </div>
                <div className="row" style={{paddingTop:'25%'}}>
                  {seat3.tableStack.amount > 0
                  ? <span className="coinAmtSeat3 playerPotAmt" style={{float:'left'}}>
                      {seat3.tableStack.amount}
                    </span>
                  : null}
                </div>
              </div>
            </div>
            <div className='col-md-1 col-xs-1'>
            </div>
            {/*seat 2 coins*/}
            <div className='col-md-2 col-xs-2'>
              <div className="seat2Chips" style={{marginTop:"-23%"}}>
                <div className="row">
                  {seat2.tableStack.imgStack.map((chip, index) => {
                    return (
                      <div key={index} className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                      {chip['chip'+index].map((coinUrl, index) => {
                        return <img key={index} src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                      })}
                      </div>
                    )
                  })}
                </div>
                <div className="row" style={{paddingTop:'25%'}}>
                  {seat2.tableStack.amount > 0
                  ? <span className="playerPotAmt" style={{float:'left'}}>
                      {seat2.tableStack.amount}
                    </span>
                  : null}
                </div>
              </div>
            </div>
            <div className='col-md-1 col-xs-1'>
            </div>
          </div>
          <div className='col-md-3 col-xs-3'>
          </div>
        </div>

        <div className="row" id="secondRowDealer" style={{paddingTop:'30%'}}>
          <div className='col-md-3 col-xs-3'>
          </div>
          <div className='col-md-6 col-xs-6'>
            <div className='col-md-2 col-xs-2'>
            </div>
            {/*seat 4 dealer*/}
            <div className='col-md-1 col-xs-1'>
              {seat4.dealer
                ? <img className='dealerButton4' src={this.state.dealerButton} style={{width: '100%', marginLeft: '90%', marginTop:'-10px'}}/>
                : <img className='dealerButton4' src={""} style={{width: '100%', marginLeft: '90%', marginTop:'-10px'}}/>
              }
            </div>
            <div className='col-md-3 col-xs-3'>
            </div>
            {/*seat 3 dealer*/}
            <div className='col-md-1 col-xs-1'>
              {seat3.dealer
                ? <img className='dealerButton3' src={this.state.dealerButton} style={{width: '100%', marginLeft: '90%', marginTop:'-10px'}}/>
                : <img className='dealerButton3' src={""} style={{width: '100%', marginLeft: '90%', marginTop:'-10px'}}/>
              }
            </div>
            <div className='col-md-2 col-xs-2'>
            </div>
            {/*seat 2 dealer*/}
            <div className='col-md-1 col-xs-1'>
              {seat2.dealer
                ? <img className='dealerButton2' src={this.state.dealerButton} style={{width: '100%', marginTop:'-10px'}}/>
                : <img className='dealerButton2' src={""} style={{width: '100%', marginTop:'-10px'}}/>
              }
            </div>
            <div className='col-md-2 col-xs-2'>
            </div>
          </div>
          <div className='col-md-3 col-xs-3'>
          </div>
        </div>

        <div className="row" id="secondRowPlayers" style={{paddingTop: "12%"}}>
          <div data-e2e="descpContent" className="col-md-2 col-xs-2" id="descpContent" style={{wordWrap: "break-word", color: 'white', left: '2%', height: '80px', marginTop:'4%', borderRadius: '6px', overflowY: 'auto', border: '1px solid white', textAlign: 'left'}}>
            {this.props.slide.description ? this.props.slide.description.trim().split("\n").map((descp,index) => {
              return <span key={index}>{descp}<br/></span>
            }):null}
          </div>
          <div className="col-md-1 col-xs-1">
          </div>
          <div className="col-md-6 col-xs-6">
            <div className="row">
              <div className="col-md-1 col-xs-1">
              </div>
              {/*seat 4*/}
              <div className="col-md-2 col-xs-2">
                <div className="row" style={{marginLeft:'-5px'}}>
                  <div className="col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                    <span style={{float: 'right', marginTop:'100%'}}>
                      <div>
                        {(seat4.cards.length == 4)
                          ?seat4.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha" />
                          })
                          :seat4.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal" />
                        })}
                      </div>
                      <div style={seat4.display.style}>{seat4.display.text}</div>
                      <div style={seat4.coinStack.style}>{numberWithCommas(seat4.coinStack.amount)}</div>
                    </span>
                  </div>
                  <div className="seatPadding col-md-7 col-xs-6" style={{padding: '5px'}}>
                    <img src={seat4.displayPicture} className="firstRowSeats" style={{float: 'left'}}/>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-xs-2">
              </div>
              {/*seat 3*/}
              <div className="col-md-2 col-xs-2" >
                <div className="row" style={{marginLeft:'-5px'}}>
                  <div className="seat3Card col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-10px'}}>
                    <span style={{float: 'right', marginTop:'100%'}}>
                      <div>
                        {(seat3.cards.length == 4)
                          ?seat3.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha"/>
                          })
                          :seat3.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal"/>
                        })}
                      </div>
                      <div style={seat3.display.style}>{seat3.display.text}</div>
                      <div style={seat3.coinStack.style}>{numberWithCommas(seat3.coinStack.amount)}</div>
                    </span>
                  </div>
                  <div className="seatPadding col-md-7 col-xs-6" style={{padding: '5px'}}>
                    <img src={seat3.displayPicture} className="firstRowSeats" style={{float: 'left'}}/>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-xs-2">
              </div>
              {/*seat 2*/}
              <div className="col-md-2 col-xs-2">
                <div className="row" style={{marginLeft:'-5px'}}>
                  <div className="seatPadding col-md-7 col-xs-6" style={{padding: '5px'}}>
                    <img src={seat2.displayPicture} className="firstRowSeats" style={{float: 'right'}}/>
                  </div>
                  <div className="col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                    <span style={{float: 'left', marginTop:'100%'}}>
                      <div>
                      {(seat2.cards.length == 4)
                        ?seat2.cards.map((card, index) => {
                          return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardOmaha"/>
                        })
                        :seat2.cards.map((card, index) => {
                          return <img key={index} id={card.imgId} src={card.imgUrl} className = "seatCardNormal"/>
                        })}
                        </div>
                        <div style={seat2.display.style}>{seat2.display.text}</div>
                        <div style={seat2.coinStack.style}>{numberWithCommas(seat2.coinStack.amount)}</div>
                      </span>
                  </div>
                </div>
              </div>
              <div className="col-md-1 col-xs-2">
              </div>
            </div>
          </div>
          <div data-e2e="playBar" className="playBar col-md-3 col-xs-3">
            <img data-e2e="refereshButton" src={this.state.replay} onTouchTap={this.props.refresh} style={{width: '16%', cursor: 'pointer'}}/>
            <img data-e2e="backwardButton" src={this.state.backward} onTouchTap={this.props.stepBackward} style={{width: '19%', cursor: 'pointer'}}/>
            {!this.props.playStatus
              ? <img data-e2e="playIconButton" src={this.state.playIcon} onTouchTap={this.props.play} style={{width: '23%', cursor: 'pointer'}}/>
              : <img data-e2e="pauseIconButton" src={this.state.pauseIcon} onTouchTap={this.props.pause} style={{width: '23%', cursor: 'pointer'}}/>
            }
            <img data-e2e="forwardButton" src={this.state.forward} onTouchTap={this.props.stepForward} style={{width: '19%', cursor: 'pointer'}}/>
          </div>
        </div>
      </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/HandReplayer/DesktopReplayer.js
 **/